import React, { Component } from 'react';
import { connect } from 'react-redux';
import NoAvailableComponent from '../FloatingSideComponents/NoAvailableComponent'
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { noAvailableSVG } from '../../../Images/NoAvailableSVG';
import { removeWorkAction } from '../../../redux/actions/A_workBar_selected';
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller';
import { DRAGGABLE_WINDOWS, WORKBAR_ACTIONS } from '../../../constants';
import { Singleton } from '../../../js/Singleton';
import { SingletonSharedData } from '../../../js/singletonSharedData';

class NoAvailableFloat extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
  }


  closeNoAvailable() {
    this.props.removeWorkAction(WORKBAR_ACTIONS.NO_AVAILABLE);
    this.props.removeWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE);
    this.sharedData.setStateWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE, false);
  }

  render() {    
    return (
      <div className={`noAvailableFloatingContainer ${(!this.props.simultaneosRecs )? 'regsMultiple' : ''} `} onClick={() => this.props.goTopZ(this.props.id)}>
        {CUSTOM_COMPONENTS["draggableHeader"](noAvailableSVG,
          this.language.getText("GUIDisableSelectorwindowTitle"),
          () => this.closeNoAvailable())}
        <NoAvailableComponent floating={false} />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { 
    simultaneosRecs: state.preview.simultaneosRecs
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    removeWorkAction: (idRemove) => { dispatch(removeWorkAction(idRemove)); }
  });
}

export default NoAvailableFloat = connect(
  mapStateToProps,
  mapDispatchToProps
)(NoAvailableFloat);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/NoAvailableFloat.jsx